import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CardInstruction from '../../../../components/CardInstruction';

import { getStatementServiceId } from '../../../form/StatementLetterForm/functions';

const Death = ({ i18n, statementServiceList }) => {
  const lang = (type, params) => i18n(`statement_letter.tab3.${type}`, { ...params });
  const serviceId = getStatementServiceId(statementServiceList, 'death');

  const stepOuterList = [
    {
      label: i18n('statement_letter.step.report_self.title')
    },
    // {
    //   label: i18n('statement_letter.step.take_number.title'),
    //   cta: i18n('statement_letter.step.take_number.cta'),
    //   link: `/statement-letter/registration/create?type=statement&serviceId=${serviceId}`
    // }
  ];

  const instructionList = [
    i18n('statement_letter.instruction_step.passport_death'),
    i18n('statement_letter.instruction_step.family_relation_death'),
    i18n('statement_letter.instruction_step.stay_permit_death'),
    i18n('statement_letter.instruction_step.proof_address_death'),
    i18n('statement_letter.instruction_step.no_fee')
  ];

  return (
    <CardInstruction
      stepOuterList={stepOuterList}
      instructionList={instructionList}
      lang={lang}
    />
  );
};

Death.propTypes = {
  i18n: PropTypes.func,
  statementServiceList: PropTypes.array
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(Death);
